var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"text-center p-10"},[_vm._v("Card Details")])}
var staticRenderFns = []

export { render, staticRenderFns }